import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'react-rrule-generator'. '/Users/dkrajnak/workspace/aviso/sse-frontend/react/node_modules/react-rrule-generator/build/index.js' implicitly has an 'any' type.
import RRuleGenerator from "react-rrule-generator";
import { SingleDatePicker } from "react-dates";
import moment from "moment";
import RRuleDomainService from "../../Domain/RRule/RRule.service";
import AutomatedScheduleDomainService from "../../Domain/AutomatedSchedule/AutomatedSchedule.service";
const CustomCalendar = ({ value, onChange, dateFormat, }) => {
    const [isCustomCalendarFocused, setIsCustomCalendarFocused] = React.useState(false);
    return (_jsx(SingleDatePicker, { id: "customCalendarSingleDatePicker", date: moment(value), onDateChange: (inputDate) => {
            if (!inputDate) {
                return;
            }
            // RRuleGenerator is expecting an event with a target.value of a string.
            const event = {
                target: {
                    value: moment(inputDate).format(dateFormat),
                },
            };
            onChange(event);
        }, numberOfMonths: 1, focused: isCustomCalendarFocused, onFocusChange: ({ focused }) => setIsCustomCalendarFocused(focused), displayFormat: "M/D/YYYY", block: true }));
};
/**
 * We need to make our own RRuleGenerator, for now just use this one from a library. This requires its inputs
 * be stringified, so we do that here.
 */
const WrappedRRuleGenerator = ({ value, onChange, }) => {
    return (_jsx("div", { className: "rruleGenerator", children: _jsx(RRuleGenerator
        // @ts-expect-error - TS7006 - Parameter 'rrule' implicitly has an 'any' type.
        , { 
            // @ts-expect-error - TS7006 - Parameter 'rrule' implicitly has an 'any' type.
            onChange: (rrule) => {
                const parsedRRule = RRuleDomainService.fromString(rrule);
                onChange(value
                    ? // @ts-expect-error - TS2345 - Argument of type '{ rrule: Flow.Diff<Options, { dstart: Date | null; }>; scheduleType: 2; nextExecutionDate: Date; lastExecutionDate: Date; endDate: Date; startDate: Date; }' is not assignable to parameter of type '(arg1: RRuleAutomatedSchedule) => RRuleAutomatedSchedule'.
                     Object.assign(Object.assign({}, value), { rrule: parsedRRule }) : Object.assign(Object.assign({}, AutomatedScheduleDomainService.BlankRRuleSchedule), { rrule: parsedRRule }));
            }, value: RRuleDomainService.toString(value === null || value === void 0 ? void 0 : value.rrule), 
            // note: the RRuleGenerator docs call for 'customCalendar' but it's actually 'calendarComponent' in the code.
            calendarComponent: CustomCalendar }) }));
};
export default WrappedRRuleGenerator;
